(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["screening"] = factory();
	else
		root["screening"] = factory();
})(this, function() {
return 


/** WEBPACK FOOTER **
 ** webpack/universalModuleDefinition
 **/